import appendScript from './appendScript'

const Utils = { appendScript }

export default Utils;
